import React from 'react'
import { Fade } from "react-awesome-reveal";
import { Helmet } from 'react-helmet-async';

function Headerbgimg() {
  return (
    <>
      <Helmet>
        {/* Balise title */}
        <title>Installation & Réparation de Quais à L'Estrie | QUAISDANROC</title>

        {/* Meta description */}
        <meta
          name="description"
          content="Spécialiste en installation et réparation de quais de chargement à L'Estrie. Service rapide, devis gratuit et intervention professionnelle. Contactez-nous !"
        />

        {/* Keywords (optionnel, mais utile pour certains moteurs) */}
        <meta
          name="keywords"
          content="Quais sur poteaux, installation quais, réparation quais, L'Estrie, , service de quais, Quais flottants,Accès au lac"
        />

        {/* Balises Open Graph (pour les réseaux sociaux) */}
        <meta property="og:title" content="Installation & Réparation de Quais à L'Estrie | QUAISDANROC" />
        <meta
          property="og:description"
          content="Spécialiste en installation et réparation de quais de chargement à L'Estrie."
        />
        <meta property="og:image" content="https://www.quaisdanroc.ca/images/gal11.jpg" />
        <meta property="og:url" content="https://www.quaisdanroc.ca" />
        <meta property="og:type" content="website" />

        {/* Balise Canonical (important pour éviter le duplicate content) */}
        <link rel="canonical" href="https://www.quaisdanroc.ca" />
      </Helmet>

      <Fade delay={100} duration={2000}>
        <section className='pt-20' id="accueil">
          <div className="w-full md:h-screen sm:h-full bg-[url('./images/header2.jpg')] bg-cover bg-center  ">
            <div className=' h-full bg-black/60'>
              <div className='md:pl-36 pt-[18em] text-white md:pb-2 md:w-[70em] sm:w-full max-sm:px-2'>
                <div className=' p-8'>
                  <h1 className='py-3 text-3xl md:text-6xl font-bold uppercase mb-4'>Réalisons ensemble le quai de vos rêves !</h1>

                </div>

              </div>
            </div>



          </div>

        </section>
      </Fade>
    </>
  )
}

export default Headerbgimg